'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SuiteCalcEditionSelectionContainer = require('pricing-pages-unified-ui/components/growth-suite-page/SuiteCalcEditionSelectionContainer');

var _SuiteCalcEditionSelectionContainer2 = _interopRequireDefault(_SuiteCalcEditionSelectionContainer);

var _SuiteAdditionalUnitsPicker = require('pricing-pages-unified-ui/components/growth-suite-page/SuiteAdditionalUnitsPicker');

var _SuiteAdditionalUnitsPicker2 = _interopRequireDefault(_SuiteAdditionalUnitsPicker);

var _SuiteCalcRequiredOnboardingSectionContainer = require('./SuiteCalcRequiredOnboardingSectionContainer');

var _SuiteCalcRequiredOnboardingSectionContainer2 = _interopRequireDefault(_SuiteCalcRequiredOnboardingSectionContainer);

var _PlanSelectorTileHeader = require('../calculator/PlanSelectorTileHeader');

var _PlanSelectorTileHeader2 = _interopRequireDefault(_PlanSelectorTileHeader);

var _Calculator = require('pricing-pages-unified-ui/components/calculator/Calculator');

var _Hubs = require('self-service-api/constants/Hubs');

var _Hubs2 = _interopRequireDefault(_Hubs);

var _CalculatorDivider = require('pricing-pages-unified-ui/components/calculator/CalculatorDivider');

var _CalculatorDivider2 = _interopRequireDefault(_CalculatorDivider);

var _CodeSplitEnvWrapper = require('pricing-pages-unified-ui/components/CodeSplitEnvWrapper');

var _CodeSplitEnvWrapper2 = _interopRequireDefault(_CodeSplitEnvWrapper);

var _Terms = require('self-service-api/constants/Terms');

var _GrowthSuiteEditionTermIdMap = require('pricing-pages-unified-ui/constants/GrowthSuiteEditionTermIdMap');

var _GrowthSuiteEditionTermIdMap2 = _interopRequireDefault(_GrowthSuiteEditionTermIdMap);

var _stateUtils = require('pricing-pages-unified-ui/utils/stateUtils');

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SuiteCalcPlanSelectorTileContainer = function SuiteCalcPlanSelectorTileContainer() {
  var _ref;

  var _useContext = (0, _react.useContext)(_Calculator.CalculatorContext),
      state = _useContext.state,
      mergeState = _useContext.mergeState;

  var activeEdition = state.activeEdition,
      activeTerm = state.activeTerm,
      marketingUnits = state.marketingUnits,
      salesUnits = state.salesUnits,
      serviceUnits = state.serviceUnits,
      selectedAddOns = state.selectedAddOns;


  var getDefaultTerm = function getDefaultTerm(edition) {
    var availableTerms = _GrowthSuiteEditionTermIdMap2.default[edition];
    return availableTerms.monthly ? _Terms.MONTHLY : _Terms.ANNUAL;
  };

  var setActiveEdition = function setActiveEdition(edition) {
    var filteredAddons = (0, _stateUtils.filterInvalidAddons)(selectedAddOns.toArray(), 'growth-suite', activeEdition, edition);

    mergeState({
      activeEdition: edition,
      marketingUnits: 0,
      salesUnits: 0,
      serviceUnits: 0,
      activeTerm: getDefaultTerm(edition),
      selectedAddOns: (0, _immutable.Set)(filteredAddons)
    });
  };

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      _PlanSelectorTileHeader2.default,
      null,
      _react2.default.createElement(_CodeSplitEnvWrapper2.default, {
        authedComponentLoader: function authedComponentLoader() {
          return import( /* webpackChunkName: "authed-chunk" */'pricing-pages-unified-ui/components/growth-suite-page/SuiteTermSelectorContainer');
        },
        authedComponentProps: {
          activeEdition: activeEdition,
          activeTerm: activeTerm,
          onChange: function onChange(term) {
            return mergeState({ activeTerm: term });
          }
        }
      })
    ),
    _react2.default.createElement(_SuiteCalcEditionSelectionContainer2.default, {
      activeEdition: activeEdition,
      setActiveEdition: setActiveEdition
    }),
    _react2.default.createElement(_SuiteCalcRequiredOnboardingSectionContainer2.default, {
      activeEdition: activeEdition,
      activeTerm: activeTerm
    }),
    _react2.default.createElement(_CalculatorDivider2.default, null),
    _react2.default.createElement(_SuiteAdditionalUnitsPicker2.default, {
      activeEdition: activeEdition,
      activeTerm: activeTerm,
      additionalUnitQuantities: (_ref = {}, _defineProperty(_ref, _Hubs2.default.HUB_MARKETING, marketingUnits), _defineProperty(_ref, _Hubs2.default.HUB_SALES, salesUnits), _defineProperty(_ref, _Hubs2.default.HUB_SERVICE, serviceUnits), _ref),
      setAdditionalUnitQuantity: function setAdditionalUnitQuantity(quantityObject) {
        return mergeState(quantityObject);
      }
    }),
    _react2.default.createElement(_CalculatorDivider2.default, null),
    _react2.default.createElement(_CodeSplitEnvWrapper2.default, {
      authedComponentLoader: function authedComponentLoader() {
        return import( /* webpackChunkName: "authed-chunk" */'pricing-pages-unified-ui/components/calculator/AddonsAndServices/AddonsAndServices');
      },
      publicComponentLoader: function publicComponentLoader() {
        return import( /* webpackChunkName: "public-chunk" */'pricing-pages-unified-ui/components/calculator/AddonsAndServices/AddonsAndServicesList');
      },
      publicComponentProps: { hub: 'growth-suite', edition: activeEdition }
    })
  );
};

exports.default = SuiteCalcPlanSelectorTileContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-page/SuiteCalcPlanSelectorTileContainer.js
// module id = 782
// module chunks = 3 4